




































import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import { column } from '../interface/'
import { ALL_GROUPS, FORM_ITEM_LAYOUT } from '../config/'
import { getWorkStats } from '../../../service/manage'
import { USER_GROUPS } from '../../../service/constant'
import { statColumns } from '../config/columns'

@Component
export default class WorkStat extends Vue {
  formItemLayout = FORM_ITEM_LAYOUT
  isNameDisabled = true
  private get groups() {
    return this.$store.state[USER_GROUPS]
  }
  mounted() {
    console.log('我所属的群组', this.groups.join(','))
    console.log('所有群组', ALL_GROUPS)
    if (this.groups.includes(ALL_GROUPS[3].id)) {
      this.isNameDisabled = false
    }
    this.renderStatList()
  }
  name: string = ''
  range: string[] = ['', '']
  statColumns: column[] = statColumns
  dataSource: any[] = []
  onRangeChange(date, dateString) {
    this.range = dateString
  }
  handleFormSubmit(e) {
    this.renderStatList()
  }
  async renderStatList() {
    const options = {
      user_name: this.name,
      start_time: this.range[0],
      end_time: this.range[1]
    }
    this.dataSource = await getWorkStats(options)
    // if (this.dataSource.length === 0) {
    //   this.dataSource = await getWorkStats({
    //     user_name: '',
    //     start_time: this.range[0],
    //     end_time: this.range[1]
    //   })
    // }
  }
}
